/* eslint-disable global-require */
const images = {
  appDownloadQrCode: require('./appDownloadQrCode.png'),
  appleStore: require('./appleStore.png'),
  googlePlayStore: require('./googlePlayStore.png'),
};

export default images;
